// import axios from "axios";
import { axios } from "Config/ApiConfig";
import API from "Constants/Apis";

export async function getSpecialBusinesses() {
  try {
    let { data } = await axios({
      baseURL: API.SITE_API_V1,
      _addToken: false,
      method: "GET",
      url: "main-page/special-businesses",
    });

    return Promise.resolve(data.data);
  } catch (err) {
    console.log(err);
  } finally {
  }
}

export async function getTopBusinesses() {
  try {
    let { data } = await axios({
      baseURL: API.SITE_API_V1,
      _addToken: false,
      method: "GET",
      url: "main-page/top-businesses",
    });

    return Promise.resolve(data.data);
  } catch (err) {
    console.log(err);
  }
}
export async function getStatistics() {
  try {
    let { data } = await axios({
      baseURL: API.SITE_API_V1,
      _addToken: false,
      method: "GET",
      url: "statistics",
    });

    return Promise.resolve(data.data);
  } catch (err) {
    console.log(err);
  }
}
